import cookieUtil from '@/library/cookieUtil';
import authorizeManage from '@/store/modules/authorizeHelper/authorizeManage';
import qs from "qs";
import api from "@/api";
import instantiationPromise from "@/library/promiseTool";
import userAgentHelper from '@/library/userAgentHelper'

//创建一个全局的promise
let {resolve:_resolve ,reject:_reject, promise:_promise} = instantiationPromise ();
let temp_mogo_default = cookieUtil.getCookie('mogo_default', true) || {};
let promisePending = false;
let browser = userAgentHelper.browser;

const authorize = {
  //登录状态数据结构， 并且需要从cooke初始化
  state: {
    userId: temp_mogo_default.userId,
    mobile: temp_mogo_default.mobile,
    token: temp_mogo_default.token,
    timestamp: temp_mogo_default.timestamp,
    isCredit: temp_mogo_default.isCredit,
    hasLease: temp_mogo_default.hasLease
  },
  mutations: {
    //写登录状态到state 和cookie
    setAuth(state, payload) {
      state.userId = payload.userId;
      state.mobile = payload.mobile;
      state.token = payload.token;
      state.timestamp = payload.timestamp;

    },
    //重置登录状态state,cooke。并重置_promise
    resetAuth(state) {
      state.userId = "";
      state.mobile = "";
      state.token = "";
      state.timestamp = "";
      state.isCredit = null;
      state.hasLease = null;
    },
    setCredit(state, isCredit) {
      state.isCredit = isCredit;
    },
    setLease(state, hasLease) {
      state.hasLease = hasLease;
    }
  },
  getters: {
    //得到登录状态，config={auth//未登录是否去登录, replaceUrl//跳转到登录页使用push还是replace方式}
    //返回全局的_promise
    authorize(state) {
      return (config = { auth: true, replaceUrl: false }) => {
        if (state.token && state.userId) {
          _resolve(state)
          return _promise;
        }
        if (promisePending || window.redirectPre) {
          return _promise;
        }
        let tempQuery = qs.parse(window.location.href.split('?')[1]);
        if ((tempQuery.code && tempQuery.code.length > 0) || (tempQuery.auth_code && tempQuery.auth_code.length > 0)) {
          promisePending = true;
          authorizeManage.doCode();
        }
        if ((config.auth || browser === 'MGRenter') && !promisePending) {
          promisePending = true;
          authorizeManage.doAuth(config, (e) => {
            promisePending = false;
            _reject(e)
          });
        }
        if (!config.auth && !promisePending) {
          _reject('未登录')
        }
        return _promise;
      }
    },
    //是否登录
    //返回布尔值
    isAuthorize(state) {
      return state.token && state.userId;
    }
  },
  actions: {
    setAuth({ commit }, auth) {
      auth.timestamp = new Date().valueOf();
      commit("setAuth", auth);
      cookieUtil.setCookie('mogo_default', auth);
      //promisePending = false;
      _resolve(auth);
    },
    errorAuth({ commit }, data) {
      _reject(data);
      window.setTimeout(() => {
        ({resolve:_resolve ,reject:_reject, promise:_promise} = instantiationPromise ());
        commit("resetAuth");
        cookieUtil.delCookie('mogo_default');
        promisePending = false;
      }, 2000);
    },
    resetAuth({ commit }) {
      ({resolve:_resolve ,reject:_reject, promise:_promise} = instantiationPromise ());
      commit("resetAuth");
      cookieUtil.delCookie('mogo_default');
      promisePending = false;
    },
    setCredit({ commit }) {
      api.loan.isCredit().then((res) => {
        if (res.data.code == '10000' && res.data.content) {
          commit("setCredit", res.data.content.isCredit);
          let temp_mogo_default = cookieUtil.getCookie('mogo_default', true) || {};
          temp_mogo_default.isCredit = res.data.content.isCredit;
          cookieUtil.setCookie('mogo_default', temp_mogo_default);
        }
      })
    },
    setLease({ commit }) {
      api.renterembedSale.hasLease().then((res) => {
        if (res.data.code == '10000' && res.data.content) {
          commit("setLease", res.data.content.hasLease);
          let temp_mogo_default = cookieUtil.getCookie('mogo_default', true) || {};
          temp_mogo_default.hasLease = res.data.content.hasLease;
          cookieUtil.setCookie('mogo_default', temp_mogo_default);
        }
      })
    },
    setAuthPending ({commit}, pending) {
      promisePending = pending;
    }
  }
}


export default authorize



// WEBPACK FOOTER //
// ./src/store/modules/authorize.js